import { mouseEventTranslator } from "./mouseEvents";
import { touchEventTranslator } from "./touchEvents";
import { focusEventTranslator } from "./focusEvents";
import { keyboardEventTranslator } from "./keyboardEvents";
export const eventTranslators = Object.assign(Object.assign(Object.assign(Object.assign({}, mouseEventTranslator), touchEventTranslator), focusEventTranslator), keyboardEventTranslator);
//# sourceMappingURL=types.js.map